import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { Camera } from '@capacitor/camera'
import { Capacitor } from '@capacitor/core'
import { Filesystem } from '@capacitor/filesystem'

const MEDIA_PERMISSION_DENIED = 'MEDIA_PERMISSION_DENIED'

export class MediaPermissionDeniedError extends Error {
  constructor() {
    super('Photo or camera permission was denied.')
    this.name = MEDIA_PERMISSION_DENIED
  }
}

export const isMediaPermissionDeniedError = (error: unknown) => {
  return error instanceof Error && error.name === MEDIA_PERMISSION_DENIED
}

export const requestFileSystemPermission = async () => {
  const permission = await Filesystem.checkPermissions()
  if (permission.publicStorage === 'denied') return false
  if (permission.publicStorage !== 'granted') {
    const requestedPermission = await Filesystem.requestPermissions()
    return requestedPermission.publicStorage === 'granted'
  }
  return true
}

export const hasDeniedMediaPermissions = async ({
  camera = true,
  photos = true,
  fileSystem = false,
}: {
  camera?: boolean
  photos?: boolean
  fileSystem?: boolean
} = {}) => {
  if (Capacitor.isNativePlatform() === false) return false

  const cameraPermissions = await Camera.checkPermissions()

  if (camera && cameraPermissions.camera === 'denied') return true
  if (photos && cameraPermissions.photos === 'denied') return true

  if (fileSystem) {
    const fileSystemPermissions = await Filesystem.checkPermissions()
    if (fileSystemPermissions.publicStorage === 'denied') return true
  }

  return false
}

const MediaPermissionRequiredModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
      <ModalOverlay />
      <ModalContent mx="16px">
        <ModalHeader pb="8px">Allow photo access</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text color="#3B4654" fontSize="sm" lineHeight="22px">
            LVBL can't open your photos because access was previously denied. Open your device Settings, choose LVBL,
            and allow Photos access. If you want to take a new picture, allow Camera access too, then return to LVBL
            and try again.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="heavy" w="100%" onClick={onClose}>
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default MediaPermissionRequiredModal
